import { useQuery } from "@tanstack/react-query";
import { getBloomreachConsentCategories } from "../../api/bBloomreachApi";

export const useGetBloomreachConsentCategories = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["bloomreach-consent-categories", organisationId],
    queryFn: () => getBloomreachConsentCategories(organisationId),
    enabled: Boolean(organisationId) && enabled,
  });
};
